import axios, { AxiosPromise } from 'axios';
import { IDomain } from '../../@types/model/masterData/domain/domain';
import { IDomainUpsert } from '../../@types/model/masterData/domain/domainUpsert';

export default class DomainHttpService {
    public static getDomainData() : AxiosPromise<Array<IDomain>> {
        return axios.get(`${API_URL}/v1/Rights/Domain/GetList`);
    }

    public static addOrUpdateDomain(upsert : IDomainUpsert) : AxiosPromise<IDomain> {
        return axios.post(`${API_URL}/v1/Rights/Domain/PostDomain`, upsert);
    }

    public static deleteDomain(domainId : number) : AxiosPromise<IDomain> {
        return axios.delete(`${API_URL}/v1/Rights/Domain/Delete`, {
            params : { domainId },
        });
    }
}
